import { getLocalizedIntegrationDetail } from "./integrationSeo.js";

const PRIORITY_COPY = {
  vmix: {
    pl: {
      eyebrow: "vMix + MediaDock",
      title: "Jak wysłać SRT z vMix do chmury i dalej do wielu wyjść",
      lead: "Połącz realizację vMix z MediaDock, aby zamienić pojedynczy program w kontrolowany workflow transmisji: stabilny transport SRT, dystrybucja do platform, player HLS i nagranie gotowe do publikacji.",
      sections: [
        {
          title: "Od miksu vMix do bezpiecznego transportu SRT",
          paragraphs: [
            "vMix może pozostać centrum realizacji obrazu, miksu audio, scen i playlist. MediaDock przejmuje warstwę transportu oraz dalszej dystrybucji, dzięki czemu operator nie musi przebudowywać istniejącego stanowiska, gdy produkcja rośnie albo pojawiają się kolejne miejsca publikacji.",
            "Najczęściej konfigurujemy wyjście SRT Caller z vMix do endpointu MediaDock. Po stronie MediaDock można przypisać strumień do produkcji, ustawić tryb listener/rendezvous, kontrolować opóźnienie i przygotować osobne wyjścia bez dotykania scen w vMix.",
          ],
        },
        {
          title: "Co zyskuje operator transmisji",
          paragraphs: [
            "W jednym miejscu widzisz stan ingestu, parametry połączenia, aktywne wyjścia i zużycie transferu. To ogranicza liczbę ręcznych przełączeń między panelem realizacyjnym, dostawcami CDN i narzędziami do nagrywania.",
            "Dla produkcji zdalnych ważne jest także rozdzielenie problemu źródła od problemu platformy docelowej. Gdy vMix wysyła poprawny SRT, a jedno wyjście ma awarię, MediaDock może utrzymać pozostałe wyjścia i pokazać operatorowi, gdzie faktycznie wystąpiła usterka.",
          ],
        },
      ],
      implementation: [
        "Utwórz strumień ingest w MediaDock i wybierz SRT jako protokół wejściowy.",
        "Skopiuj host, port, stream ID i tryb szyfrowania do konfiguracji vMix.",
        "Dodaj wyjścia RTMP, HLS, nagrywanie lub player PPV zależnie od scenariusza.",
        "Przetestuj reconnect, opóźnienie i zachowanie przy chwilowej utracie łącza przed emisją.",
      ],
      faq: [
        [
          "Czy muszę zmieniać sceny w vMix?",
          "Nie. MediaDock działa na granicy transportu i dystrybucji, więc sceny, mikser i playlisty mogą pozostać w vMix.",
        ],
        [
          "Czy mogę wysyłać jeden program do kilku platform?",
          "Tak. Jeden ingest SRT może zasilać wiele wyjść, a każde z nich może mieć własne parametry i status.",
        ],
        [
          "Czy workflow nadaje się do produkcji zdalnej?",
          "Tak. SRT poprawia odporność na zmienne sieci, a MediaDock dodaje monitoring, reconnect i kontrolę dalszej dystrybucji.",
        ],
      ],
    },
    en: {
      eyebrow: "vMix + MediaDock",
      title: "How to send SRT from vMix to the cloud and multiple outputs",
      lead: "Connect a vMix production to MediaDock and turn one program feed into a controlled workflow: resilient SRT transport, platform distribution, an HLS player, and a recording ready to publish.",
      sections: [
        {
          title: "From the vMix mix to secure SRT transport",
          paragraphs: [
            "vMix can remain the centre of your picture mix, audio mix, scenes, and playlists. MediaDock takes over the transport and distribution layer, so the operator does not need to rebuild the existing control position when the production grows or new destinations appear.",
            "A common setup uses vMix SRT Caller output into a MediaDock ingest endpoint. MediaDock can associate the stream with a production, set listener or rendezvous mode, control latency, and prepare separate outputs without changing the vMix scenes.",
          ],
        },
        {
          title: "What the broadcast operator gains",
          paragraphs: [
            "In one place you can see ingest health, connection parameters, active outputs, and transfer usage. That reduces manual switching between the production panel, CDN providers, and recording tools.",
            "For remote productions, it is important to separate a source problem from a destination problem. When vMix sends a healthy SRT stream but one destination fails, MediaDock can keep the other outputs running and show where the fault actually occurred.",
          ],
        },
      ],
      implementation: [
        "Create an ingest stream in MediaDock and select SRT as the input protocol.",
        "Copy the host, port, stream ID, and encryption mode into the vMix output settings.",
        "Add RTMP, HLS, recording, or PPV player outputs for the production scenario.",
        "Test reconnect, latency, and short link-loss behaviour before going live.",
      ],
      faq: [
        [
          "Do I need to change my vMix scenes?",
          "No. MediaDock sits at the transport and distribution boundary, so scenes, mixing, and playlists can stay in vMix.",
        ],
        [
          "Can one program feed multiple platforms?",
          "Yes. One SRT ingest can feed multiple outputs, each with its own parameters and status.",
        ],
        [
          "Is this suitable for remote production?",
          "Yes. SRT improves resilience on changing networks while MediaDock adds monitoring, reconnect, and distribution control.",
        ],
      ],
    },
  },
  obs: {
    pl: {
      eyebrow: "OBS + MediaDock",
      title: "Jak podłączyć OBS do grafiki Web CG, SRT i dystrybucji live",
      lead: "OBS jest elastycznym środowiskiem scen, a MediaDock dodaje do niego warstwę operacyjną: bezpieczne źródła Browser, transport SRT, centralne wyjścia i kontrolę produkcji.",
      sections: [
        {
          title: "Browser Source jako warstwa grafiki",
          paragraphs: [
            "MediaDock Web CG może być dodany w OBS jako źródło Browser. Operator otrzymuje adres sceny, a aktualizacja danych, lower thirdów i elementów rundownu odbywa się po stronie grafiki bez eksportowania kolejnych plików.",
            "Dla zespołów pracujących zdalnie oznacza to jeden model grafiki dla OBS, WebCG i innych odbiorników. Źródła można wersjonować, ograniczać tokenem i przypisywać do konkretnej produkcji.",
          ],
        },
        {
          title: "OBS jako punkt emisji",
          paragraphs: [
            "OBS może wysyłać program do MediaDock przez SRT, a MediaDock może dalej dostarczyć go do RTMP, HLS, nagrywania i playera. Taki podział pozwala utrzymać prostotę OBS bez rezygnacji z profesjonalnego monitoringu i redundancji.",
            "W praktyce warto rozdzielić sceny, audio i transport. OBS odpowiada za kompozycję, MediaDock za drogę sygnału, status wyjść i operacyjne ślady transmisji.",
          ],
        },
      ],
      implementation: [
        "Dodaj adres Web CG jako Browser Source i przypisz go do produkcji.",
        "Skonfiguruj sceny oraz audio w OBS tak jak w dotychczasowym workflow.",
        "Ustaw SRT lub RTMP jako wyjście do MediaDock zależnie od warunków sieci.",
        "Sprawdź źródła grafiki, proporcje canvasu i zachowanie po reconnect.",
      ],
      faq: [
        [
          "Czy OBS musi być uruchomiony na serwerze?",
          "Nie. OBS może działać na stanowisku operatora, a MediaDock obsługuje transport i dalszą dystrybucję.",
        ],
        [
          "Czy Web CG wymaga instalacji pluginu?",
          "Nie. W typowym scenariuszu wystarczy źródło Browser z adresem wygenerowanym dla produkcji.",
        ],
        [
          "Czy mogę zachować obecne sceny OBS?",
          "Tak. Integracja rozszerza istniejący workflow o kontrolowane źródła i wyjścia.",
        ],
      ],
    },
    en: {
      eyebrow: "OBS + MediaDock",
      title:
        "How to connect OBS to Web CG graphics, SRT, and live distribution",
      lead: "OBS is a flexible scene environment. MediaDock adds the operational layer around it: protected Browser sources, SRT transport, central outputs, and production control.",
      sections: [
        {
          title: "Browser Source as a graphics layer",
          paragraphs: [
            "MediaDock Web CG can be added to OBS as a Browser source. The operator receives a scene URL while data, lower thirds, and rundown elements update in the graphics layer without exporting new files.",
            "For remote teams, this creates one graphics model for OBS, WebCG, and other receivers. Sources can be versioned, token-protected, and assigned to a specific production.",
          ],
        },
        {
          title: "OBS as the emission point",
          paragraphs: [
            "OBS can send the program to MediaDock over SRT, while MediaDock delivers it to RTMP, HLS, recording, and a player. This keeps OBS approachable while adding professional monitoring and resilience.",
            "A practical separation is scenes and audio in OBS, with MediaDock handling the signal path, output status, and operational record of the stream.",
          ],
        },
      ],
      implementation: [
        "Add the Web CG URL as a Browser Source and assign it to the production.",
        "Keep scene and audio configuration in OBS as usual.",
        "Set SRT or RTMP as the MediaDock output based on network conditions.",
        "Check graphics sources, canvas proportions, and reconnect behaviour.",
      ],
      faq: [
        [
          "Does OBS need to run on a server?",
          "No. OBS can run at the operator position while MediaDock handles transport and distribution.",
        ],
        [
          "Does Web CG require a plugin?",
          "No. A Browser source with a production-specific URL is usually enough.",
        ],
        [
          "Can I keep my existing OBS scenes?",
          "Yes. The integration extends the workflow with controlled sources and outputs.",
        ],
      ],
    },
  },
  blackmagic: {
    pl: {
      eyebrow: "Blackmagic Design + MediaDock",
      title: "ATEM, tally i zdalna dystrybucja w jednym workflow",
      lead: "Połącz mikser ATEM i urządzenia Blackmagic z MediaDock, aby zachować precyzję lokalnej realizacji i zyskać centralną kontrolę transportu, wyjść oraz nagrań.",
      sections: [
        {
          title: "Lokalny mikser, centralny transport",
          paragraphs: [
            "ATEM może nadal odpowiadać za miks kamer, przejścia, SuperSource i sygnał programu. MediaDock przejmuje transport SRT lub RTMP, monitoring jakości i dystrybucję do odbiorców.",
            "To podejście jest wygodne dla ekip, które nie chcą zastępować sprawdzonego hardware'u aplikacją. Integracja porządkuje granicę między realizacją na miejscu a usługami działającymi w chmurze.",
          ],
        },
        {
          title: "Tally, presety i kontrola produkcji",
          paragraphs: [
            "W zależności od konfiguracji można powiązać status produkcji, presety i informacje dla operatora z harmonogramem MediaDock. Dzięki temu zespół wie, który sygnał jest aktywny i jakie wyjścia są gotowe do publikacji.",
            "Ważnym elementem wdrożenia jest test opóźnienia powrotu, zachowania po restarcie urządzenia oraz scenariusza, w którym główna platforma publikacji przestaje odpowiadać.",
          ],
        },
      ],
      implementation: [
        "Wybierz program output z ATEM jako źródło dla enkodera lub komputera emisyjnego.",
        "Skonfiguruj SRT/RTMP do MediaDock i przypisz kanał do produkcji.",
        "Zdefiniuj wyjścia, player i nagrywanie zgodnie z wymaganiami wydarzenia.",
        "Przetestuj tally, opóźnienie powrotu i procedurę awaryjną przed live.",
      ],
      faq: [
        [
          "Czy MediaDock zastępuje mikser ATEM?",
          "Nie. ATEM pozostaje warstwą lokalnej realizacji, a MediaDock rozszerza workflow o transport i dystrybucję.",
        ],
        [
          "Czy mogę użyć obecnego sprzętu Blackmagic?",
          "Tak, o ile dostarcza sygnał programu do skonfigurowanego wyjścia transportowego.",
        ],
        [
          "Czy rozwiązanie działa dla produkcji hybrydowych?",
          "Tak. Lokalny miks może zasilać zespół zdalny, platformy i archiwum równolegle.",
        ],
      ],
    },
    en: {
      eyebrow: "Blackmagic Design + MediaDock",
      title: "ATEM, tally, and remote distribution in one workflow",
      lead: "Connect ATEM and Blackmagic devices to MediaDock to keep the precision of a local production while gaining central control over transport, outputs, and recordings.",
      sections: [
        {
          title: "Local switcher, central transport",
          paragraphs: [
            "ATEM can continue to handle camera mixing, transitions, SuperSource, and the program feed. MediaDock handles SRT or RTMP transport, quality monitoring, and distribution to destinations.",
            "This is useful for crews that do not want to replace proven hardware with an application. The integration clarifies the boundary between on-site production and cloud services.",
          ],
        },
        {
          title: "Tally, presets, and production control",
          paragraphs: [
            "Depending on the setup, production status, presets, and operator information can be aligned with the MediaDock schedule. The team can see which signal is active and which outputs are ready to publish.",
            "A proper rollout should test return latency, device restart behaviour, and the scenario in which the primary publishing platform stops responding.",
          ],
        },
      ],
      implementation: [
        "Select the ATEM program output as the source for the encoder or emission computer.",
        "Configure SRT or RTMP to MediaDock and assign the channel to a production.",
        "Define outputs, player, and recording according to the event requirements.",
        "Test tally, return latency, and the fallback procedure before going live.",
      ],
      faq: [
        [
          "Does MediaDock replace an ATEM switcher?",
          "No. ATEM remains the local production layer while MediaDock adds transport and distribution.",
        ],
        [
          "Can I use existing Blackmagic hardware?",
          "Yes, as long as it provides the program feed to the configured transport output.",
        ],
        [
          "Does it work for hybrid productions?",
          "Yes. A local mix can feed a remote team, platforms, and the archive in parallel.",
        ],
      ],
    },
  },
  companion: {
    pl: {
      eyebrow: "Bitfocus Companion + MediaDock",
      title: "Sterowanie produkcją z przycisków, makr i Stream Decka",
      lead: "Połącz Bitfocus Companion z MediaDock, aby najczęściej używane akcje operacyjne były dostępne pod jednym przyciskiem: prompter, Run of Show, interkom, sceny i procedury awaryjne.",
      sections: [
        {
          title: "Panel operatorski zamiast polowania po kartach",
          paragraphs: [
            "Companion może pełnić rolę fizycznego panelu sterowania dla zespołu realizacyjnego. MediaDock dostarcza moduły i akcje, które można przypisać do przycisków, warstw, timerów i makr.",
            "W efekcie operator nie musi przełączać się między stroną promptera, rundownem, interkomem i panelem transmisji. Najważniejsze działania są widoczne w kontekście aktualnej produkcji.",
          ],
        },
        {
          title: "Makra dla powtarzalnych procedur",
          paragraphs: [
            "Jednym naciśnięciem można uruchomić sekwencję przygotowania sceny, wysłać sygnał do zespołu, zmienić stan rundy albo wywołać bezpieczny wariant awaryjny. Makra są szczególnie przydatne przy wydarzeniach, w których kilka osób wykonuje powtarzalne czynności pod presją czasu.",
            "Wdrożenie powinno zawsze zawierać mapę przycisków, opis stanów oraz test zachowania po utracie połączenia z panelem.",
          ],
        },
      ],
      implementation: [
        "Zainstaluj odpowiedni moduł Companion i skonfiguruj połączenie z MediaDock.",
        "Wybierz identyfikatory produkcji, rund i kanałów, które mają być sterowane.",
        "Zbuduj strony przycisków dla startu, live, przerw i procedury awaryjnej.",
        "Przetestuj uprawnienia, reconnect i zachowanie makr na docelowym Stream Decku.",
      ],
      faq: [
        [
          "Czy Companion steruje tylko Stream Deckiem?",
          "Nie. Companion może obsługiwać różne panele i interfejsy, a Stream Deck jest najpopularniejszym wariantem.",
        ],
        [
          "Czy mogę użyć makr dla Run of Show?",
          "Tak. Akcje mogą wspierać przechodzenie po rundownie i powtarzalne procedury produkcyjne.",
        ],
        [
          "Czy dostęp zależy od uprawnień MediaDock?",
          "Tak. Moduły powinny działać w granicach dostępu przyznanego użytkownikowi i produkcji.",
        ],
      ],
    },
    en: {
      eyebrow: "Bitfocus Companion + MediaDock",
      title: "Control production with buttons, macros, and Stream Deck",
      lead: "Connect Bitfocus Companion to MediaDock so frequent operational actions are one button away: prompter, Run of Show, intercom, scenes, and fallback procedures.",
      sections: [
        {
          title: "An operator surface instead of tab hunting",
          paragraphs: [
            "Companion can act as a physical control surface for the production team. MediaDock exposes modules and actions that can be assigned to buttons, layers, timers, and macros.",
            "The operator no longer needs to move between the prompter, rundown, intercom, and stream panel. Important actions stay visible in the context of the current production.",
          ],
        },
        {
          title: "Macros for repeatable procedures",
          paragraphs: [
            "One button can start a scene sequence, notify the team, change a rundown state, or call a safe fallback. Macros are valuable when several people repeat time-critical actions during an event.",
            "A rollout should include a button map, state descriptions, and a test of behaviour after the control panel loses its connection.",
          ],
        },
      ],
      implementation: [
        "Install the relevant Companion module and configure its MediaDock connection.",
        "Select the production, rundown, and channel identifiers to control.",
        "Build button pages for setup, live, breaks, and fallback procedures.",
        "Test permissions, reconnect, and macro behaviour on the target Stream Deck.",
      ],
      faq: [
        [
          "Does Companion only control Stream Deck?",
          "No. Companion supports several control surfaces and interfaces; Stream Deck is the most common option.",
        ],
        [
          "Can I use macros for Run of Show?",
          "Yes. Actions can support rundown navigation and repeatable production procedures.",
        ],
        [
          "Are actions limited by MediaDock permissions?",
          "Yes. Modules should operate within the access granted to the user and production.",
        ],
      ],
    },
  },
};

export const INTEGRATION_SLUGS = [
  "travelport",
  "aws",
  "university-of-television",
  "mine-media",
  "companion",
  "blackmagic",
  "vmix",
  "obs",
  "bemix-media",
  "google-jobs",
  "jooble",
  "olx",
];

export const INTEGRATION_META = {
  travelport: {
    flow: ["Travelport", "MediaDock", "Crew travel", "Production schedule"],
    image: "/media/marketing/services-network.webp",
    brand: { monogram: "TP", accent: "#1687c9" },
  },
  aws: {
    flow: ["MediaDock", "S3", "CloudFront", "VOD / delivery"],
    image: "/media/marketing/services-network.webp",
    brand: { monogram: "aws", accent: "#ff9900" },
  },
  "university-of-television": {
    flow: [
      "University of Television",
      "MediaDock Academy",
      "Crew profile",
      "Training",
    ],
    image: "/media/marketing/production-team.webp",
    brand: { monogram: "UT", accent: "#d1495b" },
  },
  "mine-media": {
    flow: ["Camera / encoder", "MiNE Media", "SRT", "MediaDock"],
    image: "/media/intent/serwer-srt-03.webp",
    brand: { monogram: "MM", accent: "#0f9f9a" },
  },
  companion: {
    flow: ["Stream Deck", "Companion", "MediaDock API", "Operator action"],
    image: "/media/integrations/companion.webp",
    brand: { monogram: "BC", accent: "#f0a21a" },
  },
  blackmagic: {
    flow: ["ATEM", "SRT / RTMP", "MediaDock", "Destinations"],
    image: "/media/integrations/blackmagic.webp",
    brand: { monogram: "BD", accent: "#222222" },
  },
  vmix: {
    flow: ["vMix", "SRT", "MediaDock", "YouTube / HLS / recording"],
    image: "/media/integrations/vmix.webp",
    brand: { monogram: "vM", accent: "#2873d1" },
  },
  obs: {
    flow: ["OBS", "Browser Source / SRT", "MediaDock", "Live outputs"],
    image: "/media/integrations/obs.webp",
    brand: { monogram: "OBS", accent: "#4e5a91" },
  },
  "bemix-media": {
    flow: ["Bemix Media", "Equipment", "SRT / NDI", "Production"],
    image: "/media/marketing/production-team.webp",
    brand: { monogram: "BM", accent: "#0c8b8a" },
  },
  "google-jobs": {
    flow: ["MediaDock Jobs", "JSON-LD", "Google Search", "Candidate"],
    image: "/media/marketing/services-network.webp",
    brand: { monogram: "G", accent: "#4285f4" },
  },
  jooble: {
    flow: ["MediaDock Jobs", "XML feed", "Jooble", "Candidate"],
    image: "/media/marketing/services-network.webp",
    brand: { monogram: "J", accent: "#2657c7" },
  },
  olx: {
    flow: ["MediaDock Jobs", "OAuth", "OLX", "Listing"],
    image: "/media/marketing/services-network.webp",
    brand: { monogram: "OLX", accent: "#1a9f48" },
  },
};

const genericCopy = (language, item) => {
  const name = item?.name || "this integration";
  const isPl = language.toLowerCase().startsWith("pl");
  if (isPl) {
    return {
      eyebrow: `${name} + MediaDock`,
      title: `Jak wykorzystać integrację ${name} w produkcji broadcastowej`,
      lead: `Integracja ${name} z MediaDock łączy istniejące narzędzia zespołu z warstwą produkcji, transmisji i operacyjnej kontroli. Zobacz, gdzie przebiega granica między systemami i jak zaplanować wdrożenie bez przebudowy całego workflow.`,
      sections: [
        {
          title: "Gdzie ta integracja pasuje do workflow",
          paragraphs: [
            `${item.summary} MediaDock porządkuje ten proces wokół produkcji, użytkowników, zasobów i statusu operacji, dzięki czemu ${name} nie działa jako odłączony panel, ale jako element większego przepływu pracy.`,
            "Największą wartość daje jasny podział odpowiedzialności: system partnerski pozostaje najlepszym miejscem do obsługi swojej specjalistycznej funkcji, a MediaDock przechowuje kontekst produkcji, uruchamia kolejne kroki i pomaga zespołowi zobaczyć wynik w jednym miejscu.",
          ],
        },
        {
          title: "Wdrożenie techniczne i operacyjne",
          paragraphs: [
            "Przed uruchomieniem warto opisać dane wejściowe, identyfikatory produkcji, wymagane uprawnienia, sposób obsługi błędów i zachowanie po ponownym połączeniu. Taki kontrakt ogranicza ręczne przepisywanie danych i ułatwia późniejsze skalowanie.",
            `W praktyce ${name} powinno być testowane na scenariuszu normalnym, częściowej awarii oraz zmianie operatora. MediaDock pozwala połączyć te scenariusze z harmonogramem, zasobami i komunikacją zespołu.`,
          ],
        },
      ],
      implementation: item.bullets || [],
      faq: [
        [`Do czego służy integracja ${name}?`, item.summary],
        [
          "Czy można ją wdrożyć etapami?",
          "Tak. Zacznij od jednego procesu i jednej produkcji, a następnie dodawaj kolejne dane, role i automatyzacje.",
        ],
        [
          "Co warto ustalić przed startem?",
          "Zakres danych, uprawnienia, odpowiedzialność za awarie, monitoring i procedurę ręcznego fallbacku.",
        ],
      ],
    };
  }
  return {
    eyebrow: `${name} + MediaDock`,
    title: `How to use the ${name} integration in broadcast production`,
    lead: `The ${name} integration connects an existing team tool to the production, streaming, and operational control layer in MediaDock. See where the systems meet and how to deploy the workflow without rebuilding the whole stack.`,
    sections: [
      {
        title: `Where ${name} fits in the workflow`,
        paragraphs: [
          `${item.summary} MediaDock organises that process around productions, users, resources, and operational status, so ${name} becomes part of a larger workflow rather than a disconnected panel.`,
          "The strongest results come from a clear responsibility split: the partner system remains the best place for its specialist function, while MediaDock keeps production context, starts the next steps, and gives the team one operational view.",
        ],
      },
      {
        title: "Technical and operational rollout",
        paragraphs: [
          "Before launch, document inputs, production identifiers, required permissions, error handling, and reconnect behaviour. This contract reduces manual copying and makes later scaling easier.",
          `In practice, test ${name} in a normal run, a partial failure, and an operator handover. MediaDock can connect those scenarios with the production schedule, resources, and team communication.`,
        ],
      },
    ],
    implementation: item.bullets || [],
    faq: [
      [`What is the ${name} integration for?`, item.summary],
      [
        "Can it be deployed in stages?",
        "Yes. Start with one process and one production, then add more data, roles, and automation.",
      ],
      [
        "What should be agreed before launch?",
        "Data scope, permissions, failure ownership, monitoring, and a manual fallback procedure.",
      ],
    ],
  };
};

export function getIntegrationDetail(slug, language, item) {
  return getLocalizedIntegrationDetail(slug, language, item);
}
